import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
`;
